import GpanelContactsSyncPage from '../gpanel-contacts-sync.tsx';
import {
  useLabelGroupsQuery,
  useLabelSyncsQuery,
} from '../../../gpanel-contacts-queries.ts';
import { useParams, useSearchParams } from 'react-router-dom';
import SharedBackButton from '../../../shared/components/shared-back-button.tsx';
import Stack from '@mui/material/Stack';

export default function GpanelContactsLabelSyncs() {
  let labelId = useParams().labelId!;
  const [searchParams] = useSearchParams();
  if (!labelId) {
    labelId = searchParams.get('labelId') || '';
  }

  const query = useLabelSyncsQuery(labelId);
  const syncData = query.data ?? [];
  const { data } = useLabelGroupsQuery();
  let label = null;
  for (const group of data?.labelGroups ?? []) {
    label = group.labels.find((label) => label.id.toString() === labelId);
    if (label) {
      break;
    }
  }

  return (
    <Stack width={1} sx={{ flex: 1, height: 1, overflow: 'hidden' }}>
      <SharedBackButton />
      <GpanelContactsSyncPage
        key={query.dataUpdatedAt}
        title={`${label?.name ?? 'Contact'} Syncs`}
        query={query}
        excludeColumns={['gpanelLabel']}
        showRestoreSyncButton={syncData.some(
          (sync) => sync.status === 'DISCONNECTED'
        )}
      />
    </Stack>
  );
}
